import script from "./StepAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepAmount.vue?vue&type=script&setup=true&lang=ts"

import "./StepAmount.vue?vue&type=style&index=0&id=237a40eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237a40eb"]])

export default __exports__